<template>
    <div class="header shadow-sm">
        <div class="container-lg">
            <b-navbar variant="faded" type="light">

                <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

                <router-link :to="{ name : 'home' }" class="navbar-brand">
                    <img class="header-logo" :src="global.images.logo.normal" :alt="global.name">
                    <p style="font-size:12.5px;" class="mt-1 mb-2">Στροφή στην επιτυχία</p>
                </router-link>

                <b-collapse id="nav-collapse" is-nav>

                    <b-navbar-nav class="ml-auto">


                        <b-nav-item v-if="!userIsLoggedIn & false" right @click="$router.push({ name : 'login' })" style="margin-top: 6px;text-decoration: none;">
                            <b-icon icon="person"></b-icon> {{ __('account/account.login.sign_in') }}
                        </b-nav-item>

                        <b-nav-item v-if="!userIsLoggedIn & false" right @click="$router.push({ name : 'register' })" style="margin-top: 6px;text-decoration: none;">
                            <b-icon icon="person-plus-fill"></b-icon> {{ __('account/account.register.sign_up') }}
                        </b-nav-item>

                        <b-nav-item-dropdown right>

                            <template #button-content>
                                <span style="font-size: 11px; display: none;">{{ userIsLoggedIn ? user.email : __('account/account.label') }}</span> <b-avatar :text="userFirstLetters" size="2rem"></b-avatar>
                            </template>

                            <template v-if="userIsLoggedIn">
                                <b-dropdown-header>
                                    <span style="font-weight: 700;">{{ user.first_name }} {{ user.last_name }}</span><br>
                                    <span style="font-size: 10px;">{{ user.email }}</span>
                                </b-dropdown-header>

                                <b-dropdown-divider></b-dropdown-divider>

                                <b-dropdown-item @click="$router.push({ name : 'account' })"><b-icon icon="person"></b-icon> {{ __('account/account.label') }}</b-dropdown-item>
                            </template>

                            <b-dropdown-item @click="$router.push({ name : 'account_exams' })"><b-icon icon="journal-text"></b-icon> {{ __('account/account.profile.exams.label') }}</b-dropdown-item>
                            <b-dropdown-item @click="$router.push({ name : 'account_exams_stats' })"><b-icon icon="bar-chart-line-fill"></b-icon> {{ __('account/account.profile.exams.stats.label') }}</b-dropdown-item>

                            <template v-if="userIsLoggedIn && hasRole('school-manager')">
                                <b-dropdown-divider></b-dropdown-divider>
                                <b-dropdown-item @click="$router.push({ name : 'panel_students' })"><b-icon icon="person-fill"></b-icon> {{ __('account/account.profile.students.label') }}</b-dropdown-item>
                            </template>

                            <template v-if="!userIsLoggedIn">
                                <b-dropdown-divider></b-dropdown-divider>
                                <b-dropdown-item @click="$router.push({ name : 'login' })"><b-icon icon="person"></b-icon> {{ __('account/account.login.sign_in') }}</b-dropdown-item>
                                <b-dropdown-item @click="$router.push({ name : 'register' })"><b-icon icon="person-plus-fill"></b-icon> {{ __('account/account.register.sign_up') }}</b-dropdown-item>
                            </template>

                            <template v-if="userIsLoggedIn">
                                <b-dropdown-divider></b-dropdown-divider>
                                <b-dropdown-item @click="doLogout"><b-icon icon="box-arrow-in-right"></b-icon> {{ __('account/account.login.sign_out') }}</b-dropdown-item>
                            </template>
                        </b-nav-item-dropdown>

                        <li><languages/></li>
                    </b-navbar-nav>

                </b-collapse>

            </b-navbar>

    </div>




        <nav v-if="false" class="navbar navbar-expand-md navbar-light bg-white shadow-sm">
            <div class="container">

                <router-link :to="{ name : 'home' }">
                    <img style="width:145px;" :src="global.images.logo.normal" :alt="global.name">
                </router-link>

                <template v-if="userIsLoggedIn">
                    {{ user.email }}

                    <router-link :to="{ name : 'account' }">
                        {{ __('account/account.label') }}
                    </router-link>

                    <router-link :to="{ name : 'account_exams' }">
                        {{ __('account/account.profile.exams.label') }}
                    </router-link>

                    <a @click="doLogout">
                        {{ __('account/account.login.sign_out') }}
                    </a>
                </template>

                <template v-else-if="!userIsLoggedIn">
                    <router-link :to="{ name : 'login' }">
                        <b-icon icon="person-plus-fill"></b-icon> {{ __('account/account.login.sign_in') }}
                    </router-link>

                    <router-link :to="{ name : 'register' }">
                        {{ __('account/account.register.sign_up') }}
                    </router-link>
                </template>

                <languages/>

            </div>
        </nav>
    </div>
</template>

<script type="text/babel">
    import { mapGetters } from 'vuex'
    import { mapActions } from 'vuex'

    import Vue from 'vue'
    const Languages = Vue.component('languages', require('./../helpers/Languages.vue').default);

    export default {
        name: 'Header',
        components: {
            Languages,
        },
        computed : {
            ...mapGetters({
                global : 'global',
                user : 'user',
                userIsLoggedIn : 'userIsLoggedIn',
            }),
            userFirstLetters() {
                if(this.userIsLoggedIn) {
                    let txt = '';
                    if(!_.isEmpty(this.user.first_name)) { txt  = this.user.first_name.charAt(0); }
                    if(!_.isEmpty(this.user.last_name)) { txt  += this.user.last_name.charAt(0); }
                    if(!_.isEmpty(txt)) { return txt; }
                }

                return null;
            },
        },
        methods : {
            ...mapActions({
                'logout': 'account/logout',
            }),
            doLogout() {
                this.logout().then(() => {
                    this.$router.push({ name: 'login' });
                });
            },
        },
    }
</script>
